import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconErrorFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M31.385 14.48 17.52.62A2.15 2.15 0 0 0 16 0c-.54 0-1.1.2-1.52.62L.614 14.48c-.82.84-.82 2.2 0 3.04L14.48 31.38c.42.42.98.62 1.52.62s1.1-.2 1.52-.62l13.865-13.86c.82-.84.82-2.2 0-3.04M14.667 9.237a1.333 1.333 0 1 1 2.666 0v8a1.333 1.333 0 1 1-2.666 0zm1.335 14.859a1.733 1.733 0 1 0 0-3.467 1.733 1.733 0 0 0 0 3.467" clipRule="evenodd" /></svg>;
export default SvgIconErrorFilledSmall;